import React from 'react'
import { FormDisplayErrors } from '@myxplor/forms'

const keys = [
  {
    name: 'firstName',
    label: 'First Name',
  },
  {
    name: 'lastName',
    label: 'Last Name',
  },
  {
    name: 'dateOfBirth',
    label: 'Date of birth',
  },
  {
    name: 'phone',
    label: 'Phone',
  },
  {
    name: 'email',
    label: 'Email',
  },
]

export const PersonelErrors = ({ errors }) => {
  let output = []

  keys.forEach(({ name, label }) => {
    if (errors[name]) {
      output.push(`${label} ${errors[name]}.`)
    }
  })

  return output.length > 0 ? (
    <FormDisplayErrors
      errors={[{ detail: 'The personnel you selected has some errors' }]
        .concat(output)
        .concat('You will need to update this personnel profile')}
    />
  ) : null
}



// WEBPACK FOOTER //
// ./src/providers-registrations/personnel-list/register-mancon-action/form/personnel-errors.jsx